module.exports = __webpack_public_path__ + "static/media/temp-cload-center-left.51d0677f.png";